import { iSigns } from "./Eye";
import { iDisplaySigns } from "./SignsData";

export abstract class Signs {
  abstract buildDisplaySigns(): iDisplaySigns[];

  abstract buildInitSigns(): iSigns;
}
